import { MdOutlineDeleteOutline } from 'react-icons/md'

import { Button } from '~/components/Buttons'
import ThumbVideoZoomable from '~/components/ThumbVideoZoomable'
import { formatDuration } from '~/helpers'
import i18n from '~/i18n'

const handleDeleteAsset = (data: DataAssetHandle) => {
  data.handleDeleteAsset(data)
}
export const schemaVideo = {
  image: {
    title: i18n.t('rm:media'),
    render: rowData => <ThumbVideoZoomable url={rowData?.media_url} />
  },
  fileName: {
    title: i18n.t('rm:campaign.create.Banner.table.fileName.title'),
    render: rowData => rowData?.fileMedia?.name
  },
  format_banner: {
    title: i18n.t('rm:mediaSize'),
    render: rowData => (
      <div style={{ lineHeight: 1 }}>
        <strong className="title">
          <code>
            {rowData?.dimensions?.width} x {rowData?.dimensions?.height}
          </code>
        </strong>
      </div>
    ),
    className: 'order__details col__infos col__title'
  },
  duration: {
    title: i18n.t('rm:duration'),
    render: rowData => formatDuration(rowData?.dimensions?.duration)
  },
  actions: {
    render: rowData => (
      <div style={{ textAlign: 'right' }}>
        <Button
          onClick={() => handleDeleteAsset(rowData)}
          template="transparentCritical"
          size="xsmall"
          iconLeft={<MdOutlineDeleteOutline />}
          text={i18n.t('c:actions.removeMedia')}
        />
      </div>
    )
  }
}
